<template>
  <div class="animated fadeIn list-of-book">
    <b-card>
      <div slot="header">Daily Transaction Detail
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-input-group >
                <b-input-group-prepend><label>No Kontrak </label></b-input-group-prepend>
                <b-form-input v-model="tblData.no_kontrak" placeholder="No Kontrak"></b-form-input>
                <b-input-group-prepend><span class="label-eko-md">No Aggrement</span></b-input-group-prepend>
                <b-form-input v-model="tblData.no_agreement" placeholder="No Aggrement"></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Debitur Name</label></b-input-group-prepend>
                <b-form-input v-model="tblData.CustName" placeholder="Debitur Name"></b-form-input>
                <b-input-group-prepend><span class="label-eko-md">Debitur No.</span></b-input-group-prepend>
                <b-form-input v-model="tblData.CustCode" placeholder="Debitur No / CIF"></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><span class="pt-2" style="width:100px;">Date Ref.</span></b-input-group-prepend>
              <b-form-select v-model="tblData.datereff" :plain="true" :options="optionDate"></b-form-select>
              <b-input-group-prepend><label>Period</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><label>Bank Finance</label></b-input-group-prepend>
              <b-form-input v-model="tblData.namabank" disabled ></b-form-input>
              <b-input-group-append>
                  <b-btn text="Button" @click="lkuBankaccountShow=true">
                      <i class="fa fa-search"></i>
                  </b-btn>
                  <b-button class="btn btn-danger" @click="clearbankacc" > <i class="fa fa-eraser"></i> Clear</b-button>
              </b-input-group-append>
            </b-input-group>
            <!-- <b-input-group >
              <b-input-group-prepend><label>Journal Number</label></b-input-group-prepend>
              <b-form-input v-model="tblData.nomor" placeholder="nomor (% for wildcard)"></b-form-input>
              <b-input-group-prepend><span class="pt-2">Group &nbsp;</span></b-input-group-prepend>
              <b-form-select v-model="tblData.kodejurnal" :plain="true" :options="jurnalGroup"></b-form-select>
            </b-input-group> -->
            <b-input-group >
                <b-input-group-prepend><label>Project/Cessie</label></b-input-group-prepend>
                <b-form-select v-model="tblData.pjxkey" :plain="true" :options="sourceproject"></b-form-select>
                <!-- <b-form-input v-model="tblData.kodeacc" placeholder="Account Code"></b-form-input>
                <b-form-input v-model="tblData.namaacc" placeholder="Account Name" class="ml-1" style="width:30% !important"></b-form-input>                 -->
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Reference</label></b-input-group-prepend>
              <b-form-input v-model="tblData.reff" placeholder="Reference(% wildcard)"></b-form-input>
                <b-input-group-append> <b-button class="btn btn-success ml-3 mr-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
                <b-input-group-append> <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button></b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        v-model="items" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"        
       @row-clicked="rowClicked"
       show-empty
      >
      <template v-slot:top-row="data">
          <b-td colspan="13" class="text-right"><h6>BEGINING BALANCE</h6></b-td>
          <b-td class="text-right"><h6>{{beginingbalance| numFormat('0,0.00')}}</h6></b-td>
      </template>
      <template v-slot:bottom-row="data">
          <b-td colspan="11" class="text-right"><h6>GRAND TOTAL</h6></b-td>
          <b-td class="text-right"><h6>{{totalBank_in | numFormat('0,0.00')}}</h6></b-td>
          <b-td class="text-right"><h6>{{totalBank_out | numFormat('0,0.00')}}</h6></b-td>
          <b-td class="text-right"><h6>{{ endingbalance | numFormat('0,0.00')}}</h6></b-td>
      </template>
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print JV</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>
      <template #empty="scope">
        <h6 class="text-center">{{ scope.emptyText }}</h6>
      </template>
          <template v-slot:cell(wop)="data">
          {{ data.item.wop || 'Bank' }}
        </template>
        <template v-slot:cell(tgl_terima)="data">
          {{ data.item.tgl_terima | moment("DD/MM/YY") }}
        </template>
          <template v-slot:cell(modified)="data">
          {{ data.item.modified | moment("DD/MM/YY") }}
        </template>
        <template v-slot:cell(kodeacc)="data"> 
          <span v-if="(data.item.judul=='Y') || (!data.item.namaacc)" style="color:red;"> {{data.item.kodeacc}} | {{data.item.namaacc}} </span>
          <span v-else> {{data.item.namaacc}} ({{data.item.kodeacc}})  </span>
        </template>
        <template v-slot:cell(bank_in)="data">
          {{data.item.bank_in|numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(bank_out)="data">
          {{data.item.bank_out|numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(balance)="data">
          {{data.item.balance|numFormat('0,0.00')}}
        </template>

        <template v-slot:cell(namabank)="data">
          {{data.item.namabank2}} | {{ data.item.nomorrek }}
        </template>

        <template v-slot:cell(Dim1)="data">
          <span v-if="(data.item.Dim1)">{{data.item.Dim1}} | {{data.item.Dim1Txt}}</span>
        </template>
        <template v-slot:cell(Dim2)="data">
          <span v-if="(data.item.Dim2)">{{data.item.Dim2}} | {{data.item.Dim2Txt}}</span>
        </template>
        <template v-slot:cell(Dim3)="data">
          <span v-if="(data.item.Dim3)">{{data.item.Dim3}} | {{data.item.Dim3Txt}}</span>
        </template>
        <template v-slot:cell(Dim4)="data">
          <span v-if="(data.item.Dim4)">{{data.item.Dim4}} | {{data.item.Dim4Txt}}</span>
        </template>
        <template v-slot:cell(Dim5)="data">
          <span v-if="(data.item.Dim5)">{{data.item.Dim5}} | {{data.item.Dim5Txt}}</span>
        </template>
        <template v-slot:cell(Dim6)="data">
          <span v-if="(data.item.Dim6)">{{data.item.Dim6}} | {{data.item.Dim6Txt}}</span>
        </template>

      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-input-group >
                <b-input-group-prepend><span  class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]":plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-input-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right" vif="pagination" 
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="lkuDimShow" size="lg" :hide-footer="true" title="List of Dimension Value" :centered="true" >
        <lku-dim @click="onSelectedDim" :DimColName="tblData.DimCol" :key="tblData.DimCol"></lku-dim>
    </b-modal>        
    <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
        <lku-bankaccount @click="onSelectLkuBankaccount"></lku-bankaccount>
    </b-modal>  
  </div>
</template>

<style lang="scss">
  .list-of-book {
    table {
      td:nth-child(1) {
        width: auto;
      }
      td:nth-child(2) {
        width: auto;
      }
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
   }
   .label-eko-md{
     width: 100px !important;
     margin-left:4px;
     padding-top: 2px;
   }
</style>


<script>
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import tranbank from "../../apis/fin_tranbank";
import lkuDim from "../lookup/lkuDim";
import lkuBankaccount from "../lookup/lkuBankaccount";
import myNumber from "../../components/my-number";
import project from "../../apis/project";

toastr.init();
export default {
  data() {
    return {
      lkuDimShow:false,
      lkuBankaccountShow: false,
      showDelConfirm: false,
      horizontal: true,
      showFilter:true,
      isLoading:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      items: [],
      pagination:false,
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        tgl1:moment().format('YYYY-MM-DD'),
        tgl2:moment().format('YYYY-MM-DD'),
        // tgl1:this.$store.state.user.tglaktif,
        // tgl2:this.$store.state.user.akhirbln,
        sortBy: 'nomor',
        sortDesc: false,
        DimCol:'Dim1', kodejurnal:'',no_kontrak:'',no_agreement:'',CustName:'',CustCode:'',
        datereff:'Posting',kodebank:'',namabank:'',
        pjxkey:'',pjxname:''
      },
      sourceproject: [],
      totalBank_in:0,totalBank_out:0,beginingbalance:0,endingbalance:0,
      jurnalGroup:[{ value: '', text: '-- All Source -' }, 
              { value: 'AP%', text: '-- AP Related --' },
              { value: 'AR%', text: '-- AR Related --' },
              { value: '%JV%', text: '-- JV Manual --' },
              { value: 'BANK%', text: '-- Bank --' },
              { value: 'INV%', text: '-- Inventory --' },
          ],
      optionDate:[ 
              { value: 'Posting', text: 'Posting' },
              { value: 'Value', text: 'Value' }
          ]
    };
  },
  components: {Loading, lkuDim,lkuBankaccount,myNumber},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    dimCol() {
        return this.tblData.DimCol;
    },
    tblFields(){
      const fields=[
        // {
        //   key: "action",
        //   label: "",
        //   thStyle: "width:40px",
        //   thClass: "text-center",
        // },
          {
            key: "nomor",
            label: "Voucher Number",
            sortable: true
          },
          {
            key: "wop",
            label: "WOP",
            sortable: true
          },
           {
            key: "no_agreement",
            label: "Agreement No",
            sortable: true
          },
          {
            key: "CustName",
            label: "Customer Name",
            sortable: true
          },
          {
            key: "type_trx",
            label: "Transaction Type",
            sortable: true
          },
          {
            key: "tgl_terima",
            thStyle: "width:90px",
            label: "Value Date",
            sortable: true
          },
          {
            key: "post_date",
            thStyle: "width:90px",
            label: "Post Date",
            sortable: true
          },
           {
            key: "paymno",
            thStyle: "width:90px",
            label: "Transaction No",
            sortable: true
          },
          {
            key: "kodeacc",
            label: "Payment Allocation (COA)",
            thStyle: "width:200px",
            sortable: true
          },
            {
            key: "reference",
            label: "Ref No.",
            thStyle: "width:200px",
            sortable: true
          },
            {
            key: "nomorcek",
            label: "Giro No",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "bank_in",
            label: "Debit",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "bank_out",
            label: "Credit",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "balance",
            label: "Balance",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "namabank",
            label: "Bank Receipt",
            thStyle: "min-width:140px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          }
        ];
        // const dims = this.$store.state.dimension;
        // for (let i = 0; i < dims.length; i += 1) {
        //   fields.push(          {
        //     key: dims[i].value,
        //     // thStyle: "width:150px",
        //     label: dims[i].text,
        //     sortable: true
        //   },)
        // }

      return fields;
    }
  },
  mounted:function(){
    const {timeServer,user} = this.$store.state;
    const timeSvComp = timeServer[user.compcode];
    this.tblData.tgl1 = moment(timeSvComp).format('YYYY-MM-DD')
    this.tblData.tgl2 =moment(timeSvComp).format('YYYY-MM-DD')
  },
  watch:{
      dimCol: function(newval) {
          this.tblData.DimVal="";
          this.tblData.DimValInfo="";
          this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
      },
      'tblData.pjxkey': function (newval) {
        const obj = this.sourceproject.find(x=>x.value == newval);
        this.tblData.pjxname = obj.pjxname || '';
      }
  },
  created: async function(){
    try {
      const projectDt = await project.listbyuser();
      let sourceproject =  [{value:'',text:'-- SELECT ALL --'}];

      projectDt.map(item=>{
        item.value= item.pjxkey;
        item.text= item.pjxname;
        sourceproject.push(item)
      });


      this.sourceproject = sourceproject

            
      // if(this.sourceproject.length==1) this.tblData.pjxkey = this.sourceproject[0].value

    } catch (error) {
      
    }
      // const kodeList = await tranbank.kodejurnal();
      // this.jurnalGroup = kodeList.reduce((newArr,item) =>{
      //       newArr.push(item);
      //       return newArr;
      //   },this.jurnalGroup);

  },    
  methods: {
    onSelectLkuBankaccount(_selected) {
        this.tblData.kodebank=_selected.kode;
        this.tblData.namabank=(_selected.namabank2 || _selected.namabank) + ' | '+_selected.nomorrek;
        this.lkuBankaccountShow=false;
    },    
    onSelectedDim: function(_selected){
        this.tblData.DimVal=_selected.nama;
        this.tblData.DimValCode=_selected.kode;
        this.tblData.DimValInfo=`${_selected.kode.trim()} | ${_selected.nama}`;
        this.lkuDimShow=false;
    },    
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
          const filter = this.$store.state.filter;
          let filtered=false;
          for (var key in filter.bukujvlist) {
              this.tblData[key] = filter.bukujvlist[key];
              filtered=true;
          }
          if (filtered === true) {
            this.showFilter=filtered;
            delete filter.bukujvlist;
            this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=false; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await tranbank.report(this.tblData);     
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  console.log(error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                // this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
                try {
                  const {list,totalBank_in,totalBank_out,beginingbalance} = await tranbank.report(this.tblData); 
                  this.beginingbalance = beginingbalance;
                  this.totalBank_in=totalBank_in;
                  this.totalBank_out=totalBank_out; 
                  this.endingbalance = (beginingbalance+totalBank_in) -totalBank_out; 
                  let balance = beginingbalance; 
                  list.map((data,index)=>{
                    list[index].balance = (balance+data.bank_in) - data.bank_out;
                    balance = (balance+data.bank_in) - data.bank_out;
                  });
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  console.log(error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearbankacc(){
      this.tblData.kodebank='';
      this.tblData.namabank='';
    },
    clearFilter(ctx) {
        this.tblData.kodeacc= '';
        this.tblData.namaacc=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.kodejurnal=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.DimValCode=  '';
        this.tblData.no_kontrak='';
        this.tblData.no_agreement='';
        this.tblData.CustName='';
        this.tblData.CustCode='';
    },
    saveFilter() {
      const keys = ['uraian', 'DimCol', 'DimVal', 'DimValCode', 'tgl1', 'tgl2', 'nomor', 'kodejurnal', 'kodeacc', 'namaacc'];
      let filtered = false;
      const bukujvlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              bukujvlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          bukujvlist.page=this.tblData.page;
          bukujvlist.limit=this.tblData.limit;
          bukujvlist.sortBy=this.tblData.sortBy;
          bukujvlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.bukujvlist=bukujvlist;
          this.$store.commit("filter", filter);
      }
    },    
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.printjv();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();

    },

    add: function(data) {
        this.saveFilter();
          router.push({name :'accounting.bookfrm'});
    },
    edit: function() {
        if (this.model) {
            this.saveFilter();
            router.push({name :'accounting.bookfrm', params: { nomor: this.model.nomor, tanggal:moment(this.model.tanggal).format('YYYY-MM-DD'), kodejurnal: this.model.kodejurnal}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
       this.isLoading=true;
        await tranbank.remove(this.model);
          this.refresh();
        // const objdeleted = this.items.filter(r => ((r.nomor==this.model.nomor) && (r.tanggal==this.model.tanggal)));
        // if (objdeleted) {
        //     objdeleted.forEach((d) => {
        //           const index= this.items.findIndex(r => (r.bukukey==d.bukukey));
        //           this.items.splice(index, 1);
        //     });
        // }
        this.isLoading=false;
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    printjv: async function()
    {
       if (this.model) {
          try {
              this.reportUrl= await tranbank.printjv({ nomor: this.model.nomor, tanggal:moment(this.model.tanggal).format('YYYY-MM-DD'), kodejurnal: this.model.kodejurnal});
              this.showReport=true;
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
          toastr.warn('Please select one Data taht want to print ');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            await tranbank.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },
    close(){
      router.push("home");
    },    

  }
};
</script>
